//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    type: String
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: {
    url: function url() {
      return "statics/images/activity/".concat(this.type, ".png");
    },
    title: function title() {
      var label = "activities.".concat(this.type, ".title");
      return this.$t(label);
    }
  }
};